var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Backdrop, Box, Button, CircularProgress, Paper, Stack, Step, StepContent, StepLabel, Stepper, TextField, Typography, } from '@mui/material';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import imgLogoDetranPortal from '../../assets/images/logo-detran-portal.png';
import { useAuth } from '../../hooks/useAuth';
import { requestOtp, validateOtp } from '../../services/auth.service';
export var LoginOtpPage = function () {
    var navigate = useNavigate();
    var _a = useState(0), activeStep = _a[0], setActiveStep = _a[1];
    var _b = useState(''), email = _b[0], setEmail = _b[1];
    var _c = useState(''), otp = _c[0], setOtp = _c[1];
    var _d = useState(false), loading = _d[0], setLoading = _d[1];
    var _e = useState(null), error = _e[0], setError = _e[1];
    var loginWithToken = useAuth().loginWithToken;
    var handleEmailSubmit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var appError_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setLoading(true);
                    setError(null);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, requestOtp(email)];
                case 2:
                    _b.sent();
                    setActiveStep(1);
                    return [3 /*break*/, 5];
                case 3:
                    appError_1 = _b.sent();
                    setError((_a = appError_1.message) !== null && _a !== void 0 ? _a : 'Erro inesperado. Tente novamente mais tarde.');
                    return [3 /*break*/, 5];
                case 4:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleOtpSubmit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var token, appError_2;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setLoading(true);
                    setError(null);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 5, 6, 7]);
                    return [4 /*yield*/, validateOtp(email, otp)];
                case 2:
                    token = _b.sent();
                    if (!(token.success && !!token.accessToken)) return [3 /*break*/, 4];
                    return [4 /*yield*/, loginWithToken(token.accessToken)];
                case 3:
                    _b.sent();
                    _b.label = 4;
                case 4:
                    navigate('/');
                    return [3 /*break*/, 7];
                case 5:
                    appError_2 = _b.sent();
                    setError((_a = appError_2.message) !== null && _a !== void 0 ? _a : 'Erro inesperado. Tente novamente mais tarde.');
                    return [3 /*break*/, 7];
                case 6:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 7: return [2 /*return*/];
            }
        });
    }); };
    var handleBackToLogin = function () {
        navigate('/login');
    };
    var handleBackStep = function () {
        setActiveStep(function (prevStep) { return Math.max(prevStep - 1, 0); });
        setError(null);
    };
    return (_jsxs(Stack, { sx: {
            width: '100vw',
            height: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#093089',
            overflow: 'hidden',
        }, children: [_jsxs(Paper, { elevation: 24, sx: {
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    width: '100%',
                    borderRadius: '33px',
                    maxWidth: '420px',
                    padding: '2rem',
                    animation: 'fadeIn 0.5s ease-in-out',
                }, children: [_jsx(Box, { sx: {
                            marginBottom: '2rem',
                            marginTop: '2rem',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }, children: _jsx("img", { src: imgLogoDetranPortal, alt: "Detran - Portal de Credenciamento", style: { maxWidth: '100%' } }) }), _jsxs(Stepper, { activeStep: activeStep, orientation: "vertical", sx: { width: '100%', marginTop: '1rem' }, children: [_jsxs(Step, { children: [_jsx(StepLabel, { children: activeStep !== 0 && _jsx(Typography, { children: "Informe seu E-mail" }) }), _jsx(StepContent, { children: _jsxs(Box, { sx: { position: 'relative', marginTop: '-38px' }, children: [loading && (_jsx(Backdrop, { sx: {
                                                        bgcolor: 'rgba(255, 255, 255, 0.5)',
                                                        color: 'primary.main',
                                                        zIndex: function (theme) { return theme.zIndex.drawer + 1; },
                                                        position: 'absolute',
                                                    }, open: true, children: _jsx(CircularProgress, { color: "inherit" }) })), _jsx(TextField, { variant: "outlined", fullWidth: true, placeholder: "Informe seu E-mail", value: email, onChange: function (e) { return setEmail(e.target.value); }, error: !!error && activeStep === 0, helperText: error && activeStep === 0 ? error : '', disabled: loading }), _jsxs(Stack, { direction: "row", spacing: 2, mt: 2, children: [_jsx(Button, { variant: "contained", onClick: handleEmailSubmit, disabled: !email || loading, children: "Enviar C\u00F3digo" }), _jsx(Button, { variant: "text", onClick: handleBackToLogin, disabled: loading, children: "Voltar" })] })] }) })] }), _jsxs(Step, { children: [_jsxs(StepLabel, { children: [activeStep === 0 && _jsx(Typography, { children: "Informe o C\u00F3digo" }), activeStep !== 0 && (_jsx(Typography, { children: "Digite o c\u00F3digo de seis d\u00EDgitos que foi enviado para o seu e-mail." }))] }), _jsx(StepContent, { children: _jsxs(Box, { sx: { position: 'relative' }, children: [loading && (_jsx(Backdrop, { sx: {
                                                        bgcolor: 'rgba(255, 255, 255, 0.5)',
                                                        color: 'primary.main',
                                                        zIndex: function (theme) { return theme.zIndex.drawer + 1; },
                                                        position: 'absolute',
                                                    }, open: true, children: _jsx(CircularProgress, { color: "inherit" }) })), _jsx(TextField, { variant: "outlined", fullWidth: true, placeholder: "Informe o C\u00F3digo", value: otp, onChange: function (e) { return setOtp(e.target.value); }, error: !!error && activeStep === 1, helperText: error && activeStep === 1 ? error : '', disabled: loading }), _jsxs(Stack, { direction: "row", spacing: 2, mt: 2, children: [_jsx(Button, { variant: "contained", onClick: handleOtpSubmit, disabled: !otp || loading, children: "Validar C\u00F3digo" }), _jsx(Button, { variant: "text", onClick: handleBackStep, disabled: loading, children: "Voltar" })] })] }) })] })] })] }), _jsx("style", { children: "\n          @keyframes fadeIn {\n            0% { opacity: 0; transform: translateY(-20px); }\n            100% { opacity: 1; transform: translateY(0); }\n          }\n        " })] }));
};
